import React from 'react';
import { download } from '@amzn/storm-ui-icons';
import styled from 'styled-components';
import Button from '../../Button/Button';
import { withTaktFallbackId } from '../../TaktIdContext';
import Icon from '../../Icon/Icon';
import type { ButtonProps } from '../../Button/Button';
import type { IconDefinition } from '../../Icon/types';

const ButtonIcon = styled(Icon)<{ $hideLabel: boolean }>`
  margin-inline-end: ${({ theme, $hideLabel }) => ($hideLabel ? 'none' : theme.spacing.mini)};
`;

// @ts-expect-error
const InternalButton = withTaktFallbackId<ButtonProps>(Button);

export interface TriggerButtonProps extends ButtonProps {
  hideLabel?: boolean;
  icon?: IconDefinition | string;
  label: string;
  taktFallbackId?: string;
}

const TriggerButton = ({
  label,
  hideLabel = false,
  icon = download,
  taktFallbackId,
  ...props
}: TriggerButtonProps) => (
  <InternalButton
    {...props}
    aria-label={hideLabel ? label : undefined}
    taktFallbackId={taktFallbackId}
  >
    <ButtonIcon type={icon} $hideLabel={hideLabel} />
    {!hideLabel && label}
  </InternalButton>
);

export default TriggerButton;
